import type { Connection } from '../../../types/electron';
import type { ActiveConnection } from '../models/connectionTypes';

/** Saved default database of a connection, if any (trimmed, else undefined). */
export function getDatabaseFromConnectionId(
  connectionId: string | undefined,
  connections: Connection[],
  activeConnections?: ActiveConnection[]
): string | undefined {
  if (!connectionId) return undefined;
  const saved = connections.find(c => c.id === connectionId)?.database?.trim();
  if (saved) return saved;
  const active = activeConnections
    ?.find(c => c.id === connectionId)
    ?.connection.database?.trim();
  return active || undefined;
}
